import React from 'react';

/**
 * SafetyDesk81 official logo (symbol + wordmark).
 * Uses the transparent PNG placed at /logo-safetydesk81.png.
 * - `variant="light"` inverts to white on dark backgrounds via CSS filter.
 * - `showWordmark={false}` shows only the symbol crop (useful for collapsed sidebar).
 * - `size` adjusts the rendered height; width auto-scales to keep proportions.
 */
const Logo = ({ size = 'md', variant = 'dark', showWordmark = true }) => {
  const heights = {
    sm: 26,
    md: 34,
    lg: 44,
    xl: 60,
  };
  const h = heights[size] || heights.md;

  const src = variant === 'light'
    ? '/logo-safetydesk81-white.png'
    : '/logo-safetydesk81.png';

  return (
    <div className="inline-flex items-center select-none" data-testid="app-logo">
      <img
        src={src}
        alt="SafetyDesk81"
        style={{
          height: h,
          width: 'auto',
          // Collapsed: crop to just the square symbol on the left.
          ...(showWordmark
            ? {}
            : {
                width: h,
                objectFit: 'cover',
                objectPosition: 'left center',
              }),
        }}
      />
    </div>
  );
};

export default Logo;
